export const required = (message = 'This field is required') => (value: any) => {
    if (Array.isArray(value)) return !!value.length;
    if (value === undefined || value === null || value === '') {
        return message;
    }

    if (typeof value == 'string') {
        if (value.trim() == '') {
            return message;
        }
    }

    if (value === false) {
        return true;
    }

    if (value instanceof Date) {
        // invalid date won't pass
        return !isNaN(value.getTime());
    }

    if (typeof value === 'object') {
        for (const _ in value) return true;
        return message;
    }

    return !!String(value).length;
};
